; (function (angular) {
  'use strict'

  // below are all mimetypes supported for Factur-X Attachments in CHORUS PRO
  angular
    .module('kilo.config')
    .constant('facturXMimetypes', [
      'image/bmp',
      'image/gif',
      'image/g3fax',
      'application/vnd.oasis.opendocument.text',
      'application/vnd.ms-powerpoint',
      'image/tiff',
      'application/vnd.ms-excel',
      'application/x-bzip',
      'application/x-gzip',
      'image/jpeg',
      'application/pkcs7-mime',
      'application/rtf',
      'Text/plain',
      'application/xml',
      'text/csv',
      'application/x-gzip',
      'image/jpeg',
      'application/pdf',
      'image/svg+xml',
      'application/xhtml+xml',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/msword',
      'text/html',
      'application/vnd.oasis.opendocument.presentation',
      'image/png',
      'application/x-tar',
      'application/vnd.ms-excel',
      'application/zip',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/html',
      'application/vnd.oasis.opendocument.spreadsheet',
      'application/vnd.ms-powerpoint',
      'image/tiff',
      'application/xml',
      'text/xml',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'])
})(window.angular)
